module.exports = __webpack_public_path__ + "img/email.987233da.svg";